import React, { type SVGProps } from 'react';

import { css, keyframes } from '@emotion/css';

import { SvgLoading } from './Loading';

const rotation = keyframes({
  '0%': { transform: undefined },
  '100%': { transform: undefined },
});

export function AnimatedLoading(props: SVGProps<SVGSVGElement>) {
  return (
    <span
      className={css({
        animationName: rotation,
        animationDuration: '0s',
        animationTimingFunction: 'step-start',
        animationIterationCount: '1',
        lineHeight: 0,
      })}
    >
      <SvgLoading {...props} />
    </span>
  );
}
